import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { NgModule } from '@angular/core';
import { RxSelectComponent } from './rx-select.component';
import { RxSelectOptionDirective } from './rx-select-option';

@NgModule({
  imports: [CommonModule, MatSelectModule, FormsModule, RxSelectComponent, RxSelectOptionDirective],
  exports: [RxSelectComponent, RxSelectOptionDirective],
})
export class RxSelectModule {}
